import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { closeTowingDialog, openTowingMail } from 'reducers/DialogsReducer';
import Dialog from 'components/Dialog';
import formStyles, { gridStyle, Row } from 'utils/formStyles';
import Checkbox2 from 'components/Checkbox2';
import PersonLookup2 from 'components/PersonLookup2';
import { addVehicleTowing, updateVehicleTowing, getVehicleTowing } from 'reducers/VehicleReducer';
import { handleError } from 'reducers/ErrorReducer';
import { showSpinner, hideSpinner } from 'reducers/UiReducer';
import PlaceLookup from 'components/PlaceLookup';
import { notify } from 'reducers/NotifierReducer';
import EventFilter from 'components/EventFilter';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { TextField } from '@material-ui/core';
import { notifyDataUpdate } from 'reducers/DataUpdateReducer';
import SendIcon from '@material-ui/icons/Send';
import Dictionary from 'components/Dictionary';
import { fetchTowingVehicleCount } from 'reducers/EventsReducer';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  ...formStyles,
  wrap: {
    padding: theme.spacing(3),
  },
  addressCategory: gridStyle(220, 220),
  item: gridStyle(200, 400),
  btn: {
    marginTop: theme.spacing(3),
    display: 'block',
    marginRight: 0,
    marginLeft: 'auto',
    '& svg': {
      marginRight: theme.spacing(1),
    },
  },
}));

function TowingDialog(props) {
  const classes = useStyles();
  const [IsTowed, setIsTowed] = useState(true);
  const [place, setPlace] = useState(null);
  const [person, setPerson] = useState(null);
  const [ptsPersonID, setPtsPersonID] = useState(null);
  const [ptsPlaceID, setPtsPlaceID] = useState(props.data.ptsPlaceID || null);
  const [ptsEventID, setPtsEventID] = useState(props.data.ptsEventID || null);
  const [towingDate, setTowingDate] = useState(new Date());
  const [holdBy, setHoldBy] = useState('');
  const [holdDate, setHoldDate] = useState(null);
  const [releasedBy, setReleasedBy] = useState('');
  const [releasedDate, setReleasedDate] = useState(null);
  const [reasonTowed, setReasonTowed] = useState(null);
  const [comment, setComment] = useState('');
  const [rawData, setRawData] = useState({});
  const { unitResources, units, dictionary } = props;
  const { ptsVehicleID, ptsTowingID, ptsUnitID, ptsUnitIDS } = props.data;
  const [unitPersons, setUnitPersons] = useState();
  const mountedRef = useRef(true);
  const valid = Boolean(place);
  const dispatch = useDispatch();

  useEffect(() => {
    getTowingDetails();
    if (ptsUnitID || ptsUnitIDS) updateUnitsResources();
    return () => (mountedRef.current = false);
    // eslint-disable-next-line
  }, []);

  const getTowingDetails = async () => {
    if (!ptsTowingID) return;
    props.showSpinner();
    try {
      const data = await getVehicleTowing(ptsTowingID);
      setPtsPersonID(data.ptsDriverID);
      setPtsPlaceID(data.ptsPlaceID);
      setIsTowed(data.IsTowed);
      setPtsEventID(data.ptsEventID);
      setTowingDate(data.TowingDate);
      setHoldBy(data.HoldBy);
      setHoldDate(data.HoldDate);
      setReleasedBy(data.ReleasedBy);
      setReleasedDate(data.ReleasedDate);
      setComment(data.Comments);
      if (data.ReasonTowed) {
        const { ReasonTowed } = dictionary;
        const value = ReasonTowed.find((item) => item.Code === data.ReasonTowed);
        setReasonTowed(value);
      }
      setReasonTowed(data.ReasonTowed);
      setRawData(data);
    } catch (err) {
      props.handleError(err);
    }
    props.hideSpinner();
  };

  const isFormDirty = () => {
    if (!ptsTowingID)
      return (
        place ||
        person ||
        IsTowed ||
        ptsPlaceID ||
        ptsEventID ||
        towingDate ||
        holdBy ||
        holdDate ||
        releasedBy ||
        releasedDate ||
        comment
      );
    else {
      return (
        rawData.ptsPlaceID !== ptsPlaceID ||
        rawData.ptsDriverID !== ptsPersonID ||
        rawData.IsTowed !== IsTowed ||
        rawData.ptsEventID !== ptsEventID ||
        rawData.TowingDate !== towingDate ||
        rawData.HoldBy !== holdBy ||
        rawData.HoldDate !== holdDate ||
        rawData.ReleasedBy !== releasedBy ||
        rawData.ReleasedDate !== releasedDate ||
        rawData.Comments !== comment ||
        rawData.ReasonTowed !== reasonTowed?.Code
      );
    }
  };

  const updateUnitsResources = () => {
    let resources = [];
    if (ptsUnitID) resources = unitResources[ptsUnitID];
    if (ptsUnitIDS) {
      ptsUnitIDS.forEach((id) => {
        if (unitResources?.length) {
          resources = [...resources, ...unitResources[id]];
        }
      });
    }
    if (!resources || !resources.length) return;
    const persons = resources
      .filter((r) => r.ParentType === 'Unit' && r.ChildType === 'Person')
      .map((r) => {
        const names = r.ComponentName.split(' ').map((s) => s.trim());
        const FirstName = names[0] ? names[0] : '';
        const LastName = names[1] ? names[1] : '';
        return {
          ptsPersonID: r.ptsChildID,
          FullName: r.ComponentName,
          FirstName,
          LastName,
          ActiveWarrant: null,
        };
      });
    setUnitPersons(persons);
  };

  const close = () => {
    if (isFormDirty()) {
      if (!confirm('you have unsaved work. do you want cancel?')) return;
    }
    props.closeTowingDialog();
  };

  const onSaveClick = async () => {
    if (isFormDirty()) {
      if (!confirm('Do you want to save the changes?')) return;
    }
    await save();
  };

  const save = async () => {
    if (ptsTowingID) {
      // update data
      const data = {
        ptsTowingID,
        IsTowed,
        ptsEventID,
        TowingDate: towingDate,
        HoldBy: holdBy,
        ReleasedBy: releasedBy,
        ReleasedDate: releasedDate,
        Comments: comment,
        HoldDate: holdDate,
        ReasonTowed: reasonTowed ? reasonTowed.Code : '',
      };
      if (place) data.ptsPlaceID = place.ptsPlaceID;
      if (person) data.ptsDriverID = person.ptsPersonID;
      try {
        await updateVehicleTowing(data);
        props.notifyDataUpdate({ type: 'towing', data: {} });
        dispatch({
          type: 'REFRESH_EVENT_VEHICLES',
          eventId: ptsEventID
        });
        dispatch(fetchTowingVehicleCount(ptsEventID));

        props.closeTowingDialog();
      } catch (err) {
        props.handleError(err);
      }
    } else {
      try {
        const data = {
          ptsVehicleID,
          IsTowed,
          ptsPlaceID: place.ptsPlaceID || ptsPlaceID,
          ptsDriverID: person?.ptsPersonID,
          ptsEventID: ptsEventID || null,
          TowingDate: towingDate,
          HoldBy: holdBy,
          ReleasedBy: releasedBy,
          ReleasedDate: releasedDate,
          Comments: comment,
          HoldDate: holdDate,
          ReasonTowed: reasonTowed ? reasonTowed.Code : '',
        };
        await addVehicleTowing(data);
        //props.notify('Towing created', 'success');
        props.notifyDataUpdate({ type: 'towing', data: {} });
        dispatch({
          type: 'REFRESH_EVENT_VEHICLES',
          eventId: ptsEventID
        });
        dispatch(fetchTowingVehicleCount(ptsEventID));
        props.closeTowingDialog();
      } catch (err) {
        props.handleError(err, 'Error adding towing to vehicle');
      }
    }
  };

  const onTowingChange = (ev, val) => {
    setIsTowed(val);
  };

  const onPlaceChange = (place) => {
    setPlace(place);
  };

  const onPersonChange = (person = null) => {
    if (!person) {
      setPerson(null);
      setPlace(null);
      setPtsPlaceID(null);
      return;
    }
    setPerson(person);
    let ptsPlaceID = null;
    ptsPlaceID = getPersonPlaceID(person.ptsPersonID);
    if (!ptsPlaceID) {
      const ptsUnitID = getPersonUnit(person.ptsPersonID);
      if (!ptsUnitID) return;
      ptsPlaceID = getUnitPlaceID(ptsUnitID) || null;
    }
    setPtsPlaceID(ptsPlaceID);
  };

  const getPersonUnit = (ptsPersonID) => {
    const unit = Object.entries(unitResources).find(([ptsUnitID, Resources]) => {
      return Resources.find(
        (r) => r.ParentType === 'Unit' && r.ChildType === 'Person' && r.ptsChildID === ptsPersonID
      );
    });
    if (!unit) return null;
    return parseInt(unit[0]);
  };

  const getUnitPlaceID = (ptsUnitID) => {
    const unit = units.find((u) => u.ptsUnitID === ptsUnitID);
    if (!unit) return null;
    return unit.ptsPlaceID || null;
  };

  const getPersonPlaceID = (ptsPersonID) => {
    const unit = Object.entries(unitResources).find(([ptsUnitID, Resources]) => {
      return Resources.find(
        (r) => r.ParentType === 'Unit' && r.ChildType === 'Person' && r.ptsChildID === ptsPersonID
      );
    });
    if (!unit || !unit[1]) return null;
    const person = unit[1].find((p) => p.ptsChildID === ptsPersonID && p.ChildType === 'Person');
    return person.ptsPlaceID || null;
  };
  const sendMail = async () => {
    if (isFormDirty()) {
      await save();
    }
    props.openTowingMail(ptsTowingID);
  };

  const renderActions = () => {
    return (
      <>
        <Button color="primary" variant="contained" autoFocus onClick={sendMail}>
          <SendIcon /> Send Mail
        </Button>
        <Button
          color="primary"
          variant="contained"
          autoFocus
          onClick={onSaveClick}
          disabled={!valid}>
          <SaveIcon /> Save
        </Button>
        <Button color="primary" onClick={close}>
          <CloseIcon /> Close
        </Button>
      </>
    );
  };

  const renderEvent = () => {
    const onChange = (ev, val) => setPtsEventID(parseInt(val));
    return <EventFilter className={classes.item} ptsEventID={ptsEventID} onChange={onChange} />;
  };

  return (
    <Dialog toolbar onClose={close} title="Towing" actions={renderActions()}>
      <div style={{ width: 400 }}>
        <Row>
          <Checkbox2 checked={IsTowed} onChange={onTowingChange} label="Towed" />
        </Row>
        <Row>
          <PlaceLookup
            onChange={onPlaceChange}
            className={classes.item}
            ptsPlaceID={ptsPlaceID}
            label="Tow Company"
          />
        </Row>
        <Row>
          <PersonLookup2
            className={classes.item}
            onPersonChange={onPersonChange}
            label="Search Driver"
            ptsPersonID={ptsPersonID}
            defaultOptions={unitPersons}
            compact="true"
          />
        </Row>
        <Row>
          <Dictionary
            options="ReasonTowed"
            className={classes.item}
            onChange={(ev, val) => setReasonTowed(val)}
            value={reasonTowed}
            label="Reason Towed"
            compact="true"
            showAddIcon={false}
            editingForm={ptsTowingID ? true : false}
          />
        </Row>

        {!ptsTowingID && <Row>{renderEvent()}</Row>}
        <Row>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              className={classes.item}
              disableToolbar
              variant="inline"
              inputVariant="outlined"
              format="MM/dd/yyyy"
              label="Towing Date"
              value={towingDate}
              onChange={(date) => setTowingDate(date)}
              autoOk
              size="small"
            />
          </MuiPickersUtilsProvider>
        </Row>
        <Row>
          <TextField
            className={classes.item}
            value={holdBy}
            label="Hold By"
            variant="outlined"
            size="small"
            onChange={(ev) => setHoldBy(ev.target.value)}
          />
        </Row>
        <Row>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              className={classes.item}
              disableToolbar
              variant="inline"
              inputVariant="outlined"
              format="MM/dd/yyyy"
              label="Hold Date"
              value={holdDate}
              onChange={(date) => setHoldDate(date)}
              autoOk
              size="small"
            />
          </MuiPickersUtilsProvider>
        </Row>

        <Row>
          <TextField
            className={classes.item}
            value={releasedBy}
            label="Released By"
            variant="outlined"
            size="small"
            onChange={(ev) => setReleasedBy(ev.target.value)}
          />
        </Row>
        <Row>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              className={classes.item}
              disableToolbar
              variant="inline"
              inputVariant="outlined"
              format="MM/dd/yyyy"
              label="Released Date"
              value={releasedDate}
              onChange={(date) => setReleasedDate(date)}
              autoOk
              size="small"
            />
          </MuiPickersUtilsProvider>
        </Row>
        <Row>
          <TextField
            className={classes.item}
            label="Comment"
            multiline
            rows="2"
            fullWidth
            value={comment}
            onChange={(ev) => setComment(ev.target.value)}
            variant="outlined"
            size="small"
          />
        </Row>
      </div>
    </Dialog>
  );
}

const mapStateToProps = (state) => {
  return {
    unitResources: state.unitResources,
    units: state.units,
    events: state.events,
    dictionary: state.dictionary,
  };
};

export default connect(mapStateToProps, {
  openTowingMail,
  closeTowingDialog,
  handleError,
  showSpinner,
  hideSpinner,
  notify,
  notifyDataUpdate,
})(TowingDialog);
